<template>
  <div>
    <tabs
      mode="emitter"
      class="has-background-light is-border-bottom"
      :links="userReservationsLinks"
      :is-fullwidth="false"
      :current-tab="tab"
      :level="2"
      @changeView="tab = $event"></tabs>
    <table-controls-vue
      v-if="ReservationsList && ReservationsList.length"
      :has-sticky="true"
      :reload-controls="ReservationsList">
      <table class="table is-fullwidth is-marginless has-cells-vcentered">
        <thead>
          <tr class="is-size-6">
            <th class="is-nowrap">
              Ref. ADV
            </th>
            <th>Réservation</th>
            <th>Lot</th>
            <th>Programme</th>
            <th>Promoteur</th>
            <th>Aquéreur</th>
            <th class="is-nowrap">
              Prix de vente
            </th>
            <th>Acte</th>
            <th class="is-nowrap">
              Taux com. HT
            </th>
            <th>Com. HT</th>
            <th></th>
          </tr>
        </thead>
        <tbody class="is-size-6">
          <tr
            v-for="s in ReservationsList"
            :key="s.pk">
            <router-link
              tag="td"
              class="is-cell-hoverable has-cursor-pointer"
              :to="{name: 'AdvInfos', params: {id: s.pk}}">
              <span class="">{{ s.ref }}</span>
            </router-link>
            <td>
              <span v-if="s.signature_date">{{ s.signature_date|shortDate }}</span>
              <span v-else>N.C</span>
            </td>
            <router-link
              tag="td"
              class="is-cell-hoverable has-cursor-pointer"
              :to="{name: 'LotVue', params: {id: s.lot_data.pk}}">
              <span class="">{{ s.lot_data.ref }}</span>
            </router-link>
            <router-link
              tag="td"
              class="is-narrow is-cell-hoverable has-cursor-pointer"
              :to="{name: 'ProgramVue', params: {id: s.program.pk}}">
              <span
                class=""
                :title="s.program.name">{{ s.program.name | truncate }}</span>
            </router-link>
            <router-link
              v-if="s.promoteur.promoteur_details_activated"
              tag="td"
              class="is-narrow is-cell-hoverable has-cursor-pointer"
              :to="{name: 'PromoteurPresentation', params: {id: s.promoteur.pk}}">
              <span :title="s.promoteur.name">{{ s.promoteur.name | truncate }}</span>
            </router-link>
            <td
              v-else
              class="is-narrow">
              <span :title="s.promoteur.name">{{ s.promoteur.name | truncate }}</span>
            </td>
            <router-link
              tag="td"
              class="is-narrow is-cell-hoverable has-cursor-pointer"
              :to="{name: 'ContactVue', params: {id: s.contact.pk}}">
              <span class="">{{ s.contact.first_name | smallFirstName }} {{ s.contact.last_name }}</span>
            </router-link>
            <td class="is-narrow">
              {{ s.sale_price_ttc | prettyPrice }} €
            </td>
            <td><span v-if="s.sale_date">{{ s.sale_date | shortDate }}</span><span v-else>--</span></td>
            <td class="is-narrow">
              <span v-if="s.seller_remuneration">{{ s.seller_remuneration }} %</span><span v-else>--</span>
            </td>
            <td class="is-narrow">
              <span v-if="s.seller_remuneration && s.sale_price_ttc">{{ s.sale_price_ttc / 100 * s.seller_remuneration | prettyPrice }} €</span><span v-else>--</span>
            </td>
            <td class="has-text-centered actions">
              <display-button-list
                :force-drop-down="false"
                :buttons="ReservationsButtonList"
                :data="s"></display-button-list>
            </td>
          </tr>
          <!--<tr class="empty empty--row" v-for="n in ReservationsList.length < 2 ? 2 - ReservationsList.length : 0 " :key="n"><td class="is-borderless"></td></tr>-->
        </tbody>
      </table>
    </table-controls-vue>
    <div
      class="is-padding"
      v-else>
      Aucune vente à afficher
    </div>
  </div>
</template>

<script>
import { orderBy } from 'lodash'
import moment from 'moment'
import { mapGetters } from 'vuex'
import { User } from '@/mixins'

export default {
  name: 'UserReservationsList',
  mixins: [User],
  props: {
    propsTab: String
  },
  data () {
    return {
      tab: 'RESERVED',
      ReservationsButtonList: [
        {
          icon: 'fa-eye',
          // text: 'Voir',
          action: (id, adv) => {
            this.$router.push({ name: 'AdvInfos', params: { id: adv.pk } })
          }
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isManager', 'isOperator']),
    /**
      * reservations tab
      * @returns {object[]}
      */
    userReservationsLinks () {
      return [
        { link: 'PRE_RESERVED', label: 'Pré-Réservées (' + this.preReservedReservations.length + ')' },
        { link: 'RESERVED', label: 'Réservées (' + this.reservedReservations.length + ')' },
        { link: 'APPROVED', label: 'Actées (' + this.actedReservations.length + ')' },
        { link: 'CANCELED', label: 'Annulées (' + this.canceledReservations.length + ')' }
      ]
    },
    /**
      * return reservation list by tab
      * @returns {object[]}
      */
    ReservationsList () {
      if (this.tab === 'APPROVED') {
        return this.actedReservations
      } else if (this.tab === 'CANCELED') {
        return this.canceledReservations
      } else if (this.tab === 'PRE_RESERVED') {
        return this.preReservedReservations
      } else if (this.tab === 'RESERVED') {
        return this.reservedReservations
      } else {
        return []
      }
    },
    /**
      * filter reservations by status reserved
      * @returns {object[]}
      */
    reservedReservations () {
      return orderBy(this.userReservations.filter(x => x.status === 'reserved'), s => moment(s.created_on).format('x'), ['desc'])
    },
    /**
      * filter reservations by status pre_reserved
      * @returns {object[]}
      */
    preReservedReservations () {
      return orderBy(this.userReservations.filter(x => x.status === 'pre_reserved'), s => moment(s.created_on).format('x'), ['desc'])
    },
    /**
      * filter reservations by status sold
      * @returns {object[]}
      */
    actedReservations () {
      return orderBy(this.userReservations.filter(x => x.status === 'sold'), s => moment(s.created_on).format('x'), ['desc'])
    },
    /**
      * filter reservations by status canceled
      * @returns {object[]}
      */
    canceledReservations () {
      return orderBy(this.userReservations.filter(x => ['canceled'].includes(x.status)), s => moment(s.created_on).format('x'), ['desc'])
    }
  },
  watch: {},
  methods: {
  }
}
</script>
